

//BUNDLES COMPARE LOGIC
let transitionFinished = true;

let imageHeight;
$(document).ready(() => {

  $(window).on("load resize", () => {
    if (window.matchMedia("(max-width:768px)").matches) {
      imageHeight = $('.bundle-set .bundle-image-items .image').height()
      $('.bundle-set .bundle-image-items .image').removeClass('transparent hidden')
      //$('.bundle-set .bundle-image-items .bundle-included-items').addClass('transparent').removeClass('hidden').css({ 'max-height': imageHeight, 'width': 0, "padding": 0 })
      $('.bundle-set .bundle-image-items .bundle-included-items').addClass('transparent').removeClass('hidden').css({ 'max': imageHeight})

    } else {
      $('.bundle-set .bundle-image-items .image').removeClass('transparent hidden')
      $('.bundle-set .bundle-image-items .bundle-included-items').addClass('transparent hidden')
    }
  })
})


//BUNDLES COMPARE CONTAINER WIDTH LOGIC

// $(document).ready(() => {
//   let imageContainer = $('.bundles-container .bundles-collection-set .bundle-image-items img')
//   let productsIncludedContainer = $('.bundle-container .bundle-set .bundle-image-items .bundle-included-items')
//   $(window).on('load resize', () => {
//     // productsIncludedContainer && $(productsIncludedContainer).css({ 'width': $(imageContainer).width(), 'height': $(imageContainer).height() })
//   })
// })
//(end) BUNDLES COMPARE CONTAINER WIDTH LOGIC


const handleCompare = (event) => {

  if (transitionFinished) {
    console.log(event);
    transitionFinished = false;
    let includedItems = $(event.currentTarget).parent().find('.bundle-included-items')
    let bundleImage = $(event.currentTarget).parent().find('.bundle-image-tag')
    if (includedItems.hasClass('transparent')) {
      includedItems.parent().css('overflow', 'scroll')
      bundleImage.addClass('transparent')
      includedItems.removeClass('transparent hidden')
      $(event.currentTarget).removeClass('closed')
    } else {
      includedItems.parent().css('overflow', 'hidden')
      bundleImage.removeClass('transparent')
      includedItems.addClass('hidden')
      setTimeout(() => {
        includedItems.addClass('transparent')
      }, 1000)
      $(event.currentTarget).addClass('closed')
    }
    setTimeout(() => transitionFinished = true, 600)
  }
}



const handleCompareMobile = event => {
  if (transitionFinished) {
    transitionFinished = false

    let includedItems = $(event.currentTarget).parent().find('.bundle-included-items')
    //let bundleImage = $(event.currentTarget).parent().find('.image')
    let bundleImage = $(event.currentTarget).parent().find('.bundle-image-tag')

    if (includedItems.hasClass('transparent')) {
      //bundleImage.addClass('transparent').addClass('hidden')
      bundleImage.addClass('transparent')
      includedItems.removeClass('transparent')
      //includedItems.css({ 'max-height': "1000px" })
      $(event.currentTarget).removeClass('closed')
    } else {
      includedItems.css({ 'height': imageHeight })
      //bundleImage.removeClass('hidden')
      
      setTimeout(() => {
        //includedItems.addClass('transparent').css({ 'width': '0', "padding": 0 })
        includedItems.addClass('transparent')
        bundleImage.removeClass('transparent')
      }, 100)
      $(event.currentTarget).addClass('closed')
    }
    setTimeout(() => transitionFinished = true, 600)
  }
}

//(end)BUNDLES COMPARE LOGIC


